// src/utils/LgsPusulasi_engine.js
import { forms } from '../data/forms';

export const calculateLgsPusulasi = (answers) => {
    // 1. Veri tabanından (forms.js) LGS testinin hedef (target) anahtarlarını çekiyoruz
    const lgsForm = forms.find(f => f.id === 'lgs_pusulasi');
    const items = lgsForm ? lgsForm.items : [];

    // 2. Her lise türü için başlangıç puanlarını 0 olarak belirliyoruz
    const scores = {
        "Fen Lisesi": 0,
        "Sosyal Bilimler Lisesi": 0,
        "Mesleki ve Teknik Anadolu Lisesi": 0,
        "Anadolu Lisesi": 0,
        "Güzel Sanatlar ve Spor Lisesi": 0
    };

    // 3. Öğrencinin verdiği cevapları ait olduğu lise türünün puanına ekliyoruz
    if (answers) {
        Object.keys(answers).forEach(qId => {
            const question = items.find(item => item.id === parseInt(qId));
            // Eğer sorunun bir hedefi (target) varsa ve cevap boş değilse topla
            if (question && question.target && answers[qId] !== undefined) {
                scores[question.target] += parseInt(answers[qId]);
            }
        });
    }

    // 4. Ekranda (Radar Chart veya Bar Chart) çizilmesi için veriyi formata sokuyoruz
    const chartData = Object.keys(scores).map(key => ({
        subject: key,
        A: scores[key],
        fullMark: 40 // Her kategoride 10 soru var, max 4 puandan toplam 40 tam puan
    }));

    // 5. Puanları büyükten küçüğe sıralayıp birinciyi buluyoruz
    const sortedScores = [...chartData].sort((a, b) => b.A - a.A);
    const topResult = sortedScores.length > 0 && sortedScores[0].A > 0 ? sortedScores[0].subject : "Belirlenemedi";

    // 6. ReportViewer'ın anlayacağı dilde tüm veriyi paketleyip gönderiyoruz
    return {
        scores: scores,
        chartData: chartData,
        topResult: topResult,
        summary: topResult !== "Belirlenemedi" ? `Öğrencinin ilgi ve yetenekleri en yüksek oranda ${topResult} ile eşleşmektedir.` : "Yeterli veri girilmedi.",
        isCritical: false, // Psikolojik bir risk barındırmadığı için kırmızı alarm yok
        masterRisk: 'none', // Güvenli bölge (yeşil tema)
        domain: 'lgs_pusulasi'
    };
};